// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1mi_c","footer":"ModalInfo_footer__Nr_Vl"};